export default __webpack_public_path__ + "static/media/vector-dark.4db1ea30.svg";